module.exports = __webpack_public_path__ + "static/media/rifa-nissan.a80da458.jpeg";